const state = () => ({
    listingForReport: null
})
export default state
